<template>
  <div>
    <el-table
      ref="table"
      class="commonTable el-table–scrollable-y"
      :class="{ heightAuto: data.length <= 10 }"
      :data="data"
      :row-class-name="tableRowClassName"
      :show-summary="showSummary"
      :height="data.length > 10 ? TableHeight : 'auto'"
      @sort-change="sortChange"
      :summary-method="getSummaries"
      :span-method="objectSpanMethod"
      style="width: 100%"
      @row-click="RowClick"
      @selection-change="handleSelectionChange"
    >
      <slot></slot>
    </el-table>
    <el-pagination
      v-if="isShow"
      class="pagination-size"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      background
      :current-page="page.currentPage"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="page.pageSize"
      layout="prev, pager, next, jumper, total, sizes "
      :total="page.total"
    >
    </el-pagination>
  </div>
</template>

<script>
import { loadMixin, dialogMixin } from "mixin";
export default {
  name: "CommonTable",
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    showSummary: {
      type: Boolean,
      default: false,
    },
    summariesStatis: {
      type: Boolean,
      default: false,
    },
    toYuanIndex: {
      type: Number,
      default: 5,
    },
    noneIndex: {
      type: Number,
      default: 1,
    },
    isShow: {
      type: Boolean,
      default: true,
    },
    objectSpanMethod: {
      type: Function,
      default: null,
    },
    TableHeight: {
      type: String,
      default: "100%",
    },
    columnValue: {
      type: Array,
      default: () => [],
    },
    columnValuePropty: {
      type: Array,
      default: () => [],
    },
    excludeItem: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 1,
      },
    };
  },
  mixins: [loadMixin, dialogMixin],
  watch: {
    data(val) {
      if (val == undefined || val == []) {
        this.page = {
          pageSize: 10,
          currentPage: 1,
          total: 1,
        };
      }
    },
  },
  inject: ["handleScrollTop"],
  methods: {
    clearSort() {
      this.$refs.table.columns.forEach((item) => {
        item.order = "";
      });
    },
    clearSelection() {
      this.$refs.table.clearSelection();
    },
    sortChange({ column, prop, order }) {
      this.$emit("sortChange", { column, prop, order });
    },
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 == 1) {
        return "colorOne";
      } else if (rowIndex % 2 == 0) {
        return "colorTwo";
      }
      return "";
    },
    handleSizeChange(val) {
      // console.log(`每页 ${val} 条`);
      this.page.pageSize = val;
      this.page.currentPage = 1;
      this.handleScrollTop();
      this.$emit("handleChange");
    },
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`);
      this.page.currentPage = val;
      this.handleScrollTop();
      this.$emit("handleChange");
    },
    RowClick(row) {
      this.$emit("RowClick", row);
    },
    handleSelectionChange(row) {
      this.$emit("handleSelectionChange", row);
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      let total = 0;
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }

        if (this.summariesStatis && index > 0 && index <= this.noneIndex) {
          sums[index] = "--";
          return;
        }

        let values = data.map((item) => Number(item[column.property]));
        if (this.excludeItem) {
          // 机构扣税特殊配置
          values = data.map((item) => {
            if (item["orderType"] != 8) {
              return Number(item[column.property]);
            }
          });
        }

        if (!values.every((value) => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return this.accAdd(prev, curr);
            } else {
              return prev;
            }
          }, 0);

          if (index > 6 && index < 12) {
            return sums[index];
          } else if (this.summariesStatis) {
            sums[index] =
              index < this.toYuanIndex
                ? this.toDoubleThousands(sums[index])
                : sums[index];
          } else {
            sums[index] += "";
          }

          const currentIndex = this.columnValue.indexOf(column.property);
          const currentProperty = this.columnValuePropty[currentIndex];
          if (currentIndex > -1) {
            const newArr = data.map((item) => Number(item[currentProperty]));
            total = newArr.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
            sums[index] = total + " / " + sums[index];
          }
        } else {
          sums[index] = "--";
        }
      });
      return sums;
    },
  },
};
</script>

<style scoped>
.pagination-size {
  text-align: right;
  margin-top: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/CommonTable.vue